

































import Vue from 'vue'
import { CaseLogsQuery, CaseDetailsQuery } from '@/graphql-schema'
import { CaseLogs, CaseDetails } from './Case.graphql'

export type CaseReport = NonNullable<CaseDetailsQuery['caseReport']>

interface Data {
  logs: CaseLogsQuery['logs']
  caseReport: CaseReport | null
}

export default Vue.extend({
  apollo: {
    logs: {
      query: CaseLogs,
      variables() {
        return { id: this.$route.params.caseId }
      },
    },
    caseReport: {
      query: CaseDetails,
      variables() {
        return { id: this.$route.params.caseId }
      },
    },
  },
  data(): Data {
    return {
      logs: { nodes: [] },
      caseReport: null,
    }
  },
})
